<div *ngIf="loaded" #themeWrapper class="theme-wrapper {{ themeClass }} {{ customOrDefaultClass }}">

  <app-header #header></app-header>

  <app-main #main></app-main>

  <!-- <app-footer></app-footer> -->

</div>
